export default __webpack_public_path__ + "static/media/member.ecce8cbd.jpeg";